import React, { Component } from 'react';
import { Redirect, Link }   from "react-router-dom";
import Navbar               from './Navbar';
import { isAuthenticated }  from './Login'
import Breadcrumbs          from './Breadcrumbs';
import Avatar               from './Avatar';
import API                  from './server_api'
import { getMe }            from './Login';

import TimeAgo              from 'react-timeago';
import ruStrings            from 'react-timeago/lib/language-strings/ru'
import buildFormatter       from 'react-timeago/lib/formatters/buildFormatter'

import './Project.css'

const formatter = buildFormatter(ruStrings);

// это так же используется в server/routes/isEmailValid.js
// если вносятся правки тут, то надо не забыть обновить и там
function emailIsValid (email) {
    if (email === undefined)
        return false;
    //const e = sanitizeHtml(email.trim());
    const e = email.trim();
    if (e.length > 50)
        return false;
    const regexp = /\S+@\S+\.((?:com)|(?:ru))/;
    const m = e.match(regexp);
    //  есть совпадение и оно полное
    return (m !== null && m[0] === e);    
}

function User (props) {
    const icon = (props.icon==='add') ? 'img/add-user.svg' : 'img/delete-user.svg';
    const animated = props.animated ? "user-animated" : "";
    return (
        <li className={"list-group-item d-flex align-items-center "+ animated} >
            <Avatar email={props.user.email} size='80' />
            <div className='flex-grow-1 text-break ml-3'>
                <Link to={'/user/' + props.user.id} className='text-dark'>
                    <h5>{props.user.name}</h5>
                    <span>{props.user.email}</span>
                </Link>
            </div>
            <button className='close' id={props.user.id} onClick={props.func}>
                <img src={icon} id={props.user.id} height="50px" className='ml-2' alt='move user'/>
            </button>
        </li>
    );
}

function NewUser (props) {
    const editing = props.state.editing;
    // валидируем введенный емейл
    const email_valid = emailIsValid(props.state.user_email);
    return (
        <li className="list-group-item d-flex align-items-center justify-content-center">
            { editing === 'user' ||
                <button className='close'>
                    <img src='img/add-new-user.svg' 
                    onClick={ props.onNewUserButton } 
                    height="50px"
                    alt='edit'/>
                </button>
            }
            { editing === 'user' &&
                <form className="form-inline" onSubmit={ props.onCreateUserButton } autoComplete="off">
                    <div className="form-row w-100">
                        <div className="input-group mb-2 col-sm-6">
                            <input type="text" 
                                className="form-control" 
                                id="user_name" 
                                placeholder="Имя" 
                                maxLength='50'
                                onChange={props.handleInputChange}
                                value={props.state.user_name}
                                required/>
                        </div>
                        <div className="input-group mb-2 col-sm-6">
                            <div className="input-group-prepend">
                                <div className="input-group-text">@</div>
                            </div>
                            <input type="email" 
                                className={"form-control " + (email_valid ? "is-valid" :"is-invalid")}
                                id="user_email" 
                                placeholder="Email"
                                maxLength='50'
                                onChange={props.handleInputChange}
                                value={props.state.user_email}
                                required />
                        </div>
                    </div>
                    <div className="form-row px-1">
                        <button type="reset" className="btn btn-secondary mr-2" onClick={ props.onCancelButton }>Отмена</button>
                        <button type="submit" className={"btn btn-primary" + ( email_valid?"":" disabled")}>
                            Создать
                        </button>
                    </div>
                </form>
            }
        </li>
    )
}

function ProjectDescription (props) {
    const editing = props.state.editing;
    return (
        <div className="border border-light shadow-lg rounded-lg bg-white mt-4 p-4">
            { editing !== 'name' &&
                <span className='d-flex justify-content-between'>
                    <h1 className="display-4 text-break">{props.state.name}</h1>
                    { !getMe().is_admin ||  props.state.folders_num > 0 ||
                        <button className='close' disabled={ props.state.is_deleting || !props.state.is_loaded }>
                            <img src='img/edit.svg' 
                                className='align-self-start mt-4 ml-3' 
                                onClick={ props.state.is_deleting ? ()=>{} : props.clb.onEditNameButton } 
                                alt='edit'/>
                        </button>
                    }
                </span>
            }
            { editing === 'name' && 
                <form className="form-inline mb-4" onSubmit={ props.clb.onNameChangeButton } autoComplete="off">
                    <div className="form-group flex-grow-1">
                        <input type="text" 
                            className="form-control w-100 mr-2" 
                            id="nameEdit" 
                            autoFocus={true} 
                            onChange={props.clb.handleInputChange}
                            value={ props.state.nameEdit }/>
                    </div>
                    <div>
                        <button type="reset" className="btn btn-secondary mr-2" onClick={ props.clb.onCancelButton }>Отмена</button>
                        <button type="submit" className="btn btn-primary">Изменить</button>
                    </div>
                </form>
            }
            { editing !== 'description' &&                    
                <span className='d-flex justify-content-between'>
                    <p className="lead text-break">{props.state.description}</p>
                    { !getMe().is_admin ||
                        <button className='close' disabled={ props.state.is_deleting || !props.state.is_loaded }>
                            <img src='img/edit.svg' 
                                className='align-self-start mt-3 ml-3' 
                                onClick={ props.state.is_deleting ? ()=>{} : props.clb.onEditDescButton }  
                                alt='edit'/>
                        </button>
                    }
                </span>
            }
            { editing === 'description' && 
                <form className="form form mb-4" onSubmit={ props.clb.onDescChangeButton } autoComplete="off">
                    <div className="form-group flex-grow-1 mr-sm-4">
                        <textarea className="form-control w-100" 
                            id="descEdit"
                            rows="5"
                            autoFocus={true} 
                            onChange={props.clb.handleInputChange}
                            value={props.state.descEdit}/>
                    </div>
                    <div>
                        <button type="reset" className="btn btn-secondary mr-2" onClick={ props.clb.onCancelButton }>Отмена</button>
                        <button type="submit" className="btn btn-primary">Изменить</button>
                    </div>
                </form>
            }                    
            <hr className="my-4"/>
            { !props.state.is_loaded ||
                <p>Создан <strong><TimeAgo date={props.state.created} formatter={formatter}/></strong><br />
                Содержит <strong>{props.state.folders_num} папки</strong>, <strong>{props.state.files_num} файла(ов)</strong>.</p>
            }
            { props.state.folders_num > 0 || !props.state.is_loaded || !getMe().is_admin ||
                <button className="btn btn-danger btn-lg" 
                disabled={ props.state.is_deleting } 
                onClick={ props.clb.onDeleteProject } >
                    Удалить проект
                </button>
            }
        </div>
    );
}



export default class Project extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_loaded:   false,
            editing:     'none',
            name:        '',
            description: '',
            participants: new Set(), // id's of selected users
            users:        [],        // все пользователи сервиса
            moved_user:   '',        // id перемещенного пользвателся (для анимации)
            is_deleting:  false,     // отослан запрос на удаление проекта
            is_deleted:   false,     // пришел ответ, что проект удален
        };

        this.handleInputChange     = this.handleInputChange.bind(this);
        this.onEditNameButton      = this.onEditNameButton.bind(this);
        this.onNameChangeButton    = this.onNameChangeButton.bind(this);
        this.onEditDescButton      = this.onEditDescButton.bind(this);
        this.onDescChangeButton    = this.onDescChangeButton.bind(this);
        this.onCancelButton        = this.onCancelButton.bind(this);
        this.onAddUser             = this.onAddUser.bind(this);
        this.onDeleteUser          = this.onDeleteUser.bind(this);
        this.onNewUserButton       = this.onNewUserButton.bind(this);
        this.onCreateUserButton    = this.onCreateUserButton.bind(this);
        this.onProjectLoaded       = this.onProjectLoaded.bind(this);
        this.onUserCreated         = this.onUserCreated.bind(this);
        this.onDeleteProject       = this.onDeleteProject.bind(this);
    }

    onProjectLoaded(json) {
        let newstate = json;
        if ( 'users' in json ){
            newstate.participants = new Set(json.users);
            delete newstate.users;
        }
        newstate.is_loaded = true; // информация наконец загружена
        this.setState( newstate );
    }

    componentWillMount() {
        if ( isAuthenticated() ){
            API.getProject( this.onProjectLoaded, this.props.match.params.id );
            if ( getMe().is_admin )
                API.getUsersList( (json) => { this.setState( { users: json }); } );
        }
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState({ [target.id]: target.value });
    }

    onEditNameButton (event) {
        this.setState( { editing: 'name', nameEdit: this.state.name });
    }

    onNameChangeButton (event) {
        API.updateProject(this.onProjectLoaded, this.props.match.params.id, this.state.nameEdit, this.state.description );
        this.setState( { editing: 'none' });
        event.preventDefault();
    }

    onEditDescButton (event) {
        this.setState( { editing: 'description', descEdit: this.state.description });
    }

    onDescChangeButton (event) {
        API.updateProject(this.onProjectLoaded, this.props.match.params.id, this.state.name, this.state.descEdit );
        this.setState( { editing: 'none' });
        event.preventDefault();
    }

    onNewUserButton (event) {
        this.setState( { editing: 'user', user_name: '', user_email: '' });
    }

    onCancelButton (event) {
        this.setState( { editing: 'none' });
    }

    onAddUser (event) {
        let sel = this.state.participants;
        sel.add(event.target.id);
        API.updateUserProjects(()=>{}, event.target.id, this.props.match.params.id, 'add');
        this.setState( { editing: 'none', participants: sel, moved_user: event.target.id });
        event.preventDefault();
    }

    onDeleteUser (event) {
        let sel = this.state.participants;
        sel.delete(event.target.id);
        API.updateUserProjects(()=>{}, event.target.id, this.props.match.params.id, 'delete');
        this.setState( { editing: 'none', participants: sel, moved_user: event.target.id });
        event.preventDefault();
    }

    onUserCreated (json) {
        let new_users = this.state.users;
        let sel = this.state.participants;

        new_users.push(json);
        sel.add(json.id);

        this.setState( { 
            participants: sel,
            users: new_users,
            moved_user: json.id,
            editing: 'none',
        });
    }

    onCreateUserButton (event) {
        API.addUser(this.onUserCreated, this.state.user_name,  this.state.user_email.trim(), this.props.match.params.id );
        this.setState( { editing: 'none', });
        event.preventDefault();
    }

    onDeleteProject (event) {
        API.deleteProject(()=>{ this.setState( { is_deleted: true }); }, this.props.match.params.id);
        this.setState( { editing: 'none', is_deleting: true });
        event.preventDefault();
    }

    render () {
        // неавторизованных пользователей перенаправляем на страницу логина
        if ( !isAuthenticated() )
            return (<Redirect to={{ pathname: "/login", state: { from: this.props.location }}} />);

        // после удаление проекта переходим к списку проектов снова
        if ( this.state.is_deleted )
            return (<Redirect to='/' />);


        // составляем два списка пользователей
        let participants = [];
        let others = [];

        for (let i in this.state.users){
            const p = this.state.users[i];
            const animated = (p.id === this.state.moved_user);

            if ( p.is_admin ) {
                // игнорируем, у админов есть доступ везде
            }
            else if (this.state.participants.has(this.state.users[i].id))
                participants.push(<User icon='delete' user={p} key={p.id} func={this.onDeleteUser} animated={animated}/>);
            else
                others.push(<User icon='add' user={p} key={p.id} func={this.onAddUser} animated={animated}/>);
        }
        
        return ([
            <Navbar key='navbar' />,
            <Breadcrumbs key='breadcrumbs' name = {this.state.name}/>,            
            <main key='body' role="main" className="container">
                <ProjectDescription state= {this.state} clb={this} />
                { !this.state.is_loaded || this.state.is_deleting || !getMe().is_admin ||
                    <div className='d-flex flex-column flex-lg-row'>
                        <div className='flex-fill my-4 mr-lg-4'>
                            <h2 className='ml-3'>Участники проекта:</h2>
                            <ul className="list-group shadow-lg">
                                {participants}
                                <NewUser state={this.state}
                                    handleInputChange={this.handleInputChange}
                                    onNewUserButton={this.onNewUserButton}
                                    onCreateUserButton={this.onCreateUserButton}
                                    onCancelButton={this.onCancelButton} />
                            </ul>
                        </div>
                        <div className='flex-fill my-4 ml-lg-4'>
                            <h2 className='ml-3'>Остальные пользователи:</h2>
                            <ul className="list-group shadow-lg">
                                {others}
                            </ul>
                        </div>
                    </div>
                }
            </main>
        ]);
    }
}
